// extracted by mini-css-extract-plugin
module.exports = {"in-queue_root":"InQueue_in-queue_root__1ZuH2","in-queue_loading-container":"InQueue_in-queue_loading-container__2crgi"};